export default __webpack_public_path__ + "static/media/151-packaging.f1b824f9.png";